import React from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { Fullscreen, Zoom } from 'yet-another-react-lightbox/plugins';

interface ImageLightbox {
  isOpen: boolean;
  onClose: () => void;
  imageIndex?: number;
  imageSources: string[];
}

const ImageLightbox = ({ isOpen, onClose, imageIndex, imageSources }: ImageLightbox) => {
  return (
    <Lightbox
      open={isOpen}
      close={onClose}
      index={imageIndex}
      slides={imageSources?.map((src) => ({ src: `data:image/png;base64,${src}` }))}
      plugins={[Zoom, Fullscreen]}
    />
  );
};

export default ImageLightbox;
